export default "__VITE_ASSET__2445930f__"